import { connect } from 'react-redux';
import componentKeys from 'constants/componentKeys';
import { getByComponentKey } from 'selectors/meta';
import SessionScheduleView from './SessionScheduleView';

export default connect((state) => ({
  userId: getByComponentKey(componentKeys.APP_LOGIN_USER)(state),
}))(SessionScheduleView);
